import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type ParticipantFlowPageShellProps = {
  eyebrow: string;
  title: string;
  description?: string;
  children: ReactNode;
  bodyClassName?: string;
};

export default function ParticipantFlowPageShell({
  eyebrow,
  title,
  description,
  children,
  bodyClassName,
}: ParticipantFlowPageShellProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col text-[color:var(--color-foreground)]">
      <div className="theme-user-page-width theme-user-page-width--wide mx-auto grid min-h-0 flex-1 grid-rows-[auto_minmax(0,1fr)] gap-4 px-4 pb-[calc(1.5rem+env(safe-area-inset-bottom))] pt-4 md:px-5 lg:px-8 xl:gap-8 xl:px-12">
        <header className="theme-divider-soft grid gap-3 border-b pb-4">
          <div className="min-w-0 max-w-3xl">
            <p className="type-eyebrow theme-copy-muted">{eyebrow}</p>
            <h1 className="type-page-title mt-1">{title}</h1>
            {description ? (
              <p className="type-page-lead mt-3">{description}</p>
            ) : null}
          </div>
        </header>

        <div className={cn("min-h-0", bodyClassName)}>{children}</div>
      </div>
    </div>
  );
}
